const INITIAL_STATE = {
    locationExchanges:
    {
        loading: true,
        quantity: 0,
    },
    requestsAnswered: {
        loading: true,
        quantity: 0,
    },
    receivedVolumes: {
        loading: true,
        quantityVolume: 0,
        quantityVolumeReceived: 0,
        quantityMvm: 0,
        quantityMvmReceived: 0,
    },
    mvmCarregados: {
        loading: true,
        quantityLoad: 0,
        quantityUnload: 0,
    }
};

export default function monitorReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'SET_PHISICAL_CONFIRMATION_MONITOR':
            action.receivedVolumes.loading = false;
            return {
                ...state,
                receivedVolumes: action.receivedVolumes,
            };
        case 'SET_ORDERS_ATTENDED_MONITOR':
            const requestsAnsweredNew = {
                quantity: action.quantitys,
                loading: false
            }
            return {
                ...state,
                requestsAnswered: requestsAnsweredNew,
            };
        case 'SET_CHANGE_LOCATION_MONITOR':
            const locationExchangesNew = {
                quantity: action.quantitys,
                loading: false
            }
            return {
                ...state,
                locationExchanges: locationExchangesNew,
            };
        case 'SET_MVM_LOAD_UNLOAD_MONITOR':
            action.mvmCarregados.loading = false;
            return {
                ...state,
                mvmCarregados: action.mvmCarregados,
            };
        case 'RESET_MONITOR':
            return {
                ...state,
                locationExchanges: INITIAL_STATE.locationExchanges,
                requestsAnswered: INITIAL_STATE.requestsAnswered,
                receivedVolumes: INITIAL_STATE.receivedVolumes,
                mvmCarregados: INITIAL_STATE.mvmCarregados
            };
        default:
            return state;
    }
}